import PropTypes from 'prop-types'
import Modal from 'react-modal'
import React from 'react'

import rgba from 'lib/rgba'
import { breakpointMax } from 'styles/mixins'
import { createUseStyles } from 'react-jss'

const closeTransitionDuration = 300

const useStyles = createUseStyles(({ colors, zIndexes }) => ({
  overlay: {
    backgroundColor: rgba(colors.light, 0.75),
    backdropFilter: 'blur(25px)',
    bottom: 0,
    left: 0,
    opacity: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    transition: `opacity ${closeTransitionDuration}ms ease`,
    zIndex: zIndexes.modal
  },
  overlayAfterOpen: {
    opacity: 1
  },
  overlayBeforeClose: {
    opacity: 0
  },

  modal: {
    background: colors.greyExtraLight,
    borderRadius: 0,
    bottom: 0,
    boxShadow: `0px 30px 80px ${rgba(colors.primary, 0.12)}`,
    left: '50%',
    maxWidth: '100%',
    overflow: ({ overflow }) => overflow,
    padding: 0,
    position: 'fixed',
    right: 'auto',
    top: 'auto',
    transform: 'translate(-50%, 100%)',
    transition: `transform ${closeTransitionDuration}ms cubic-bezier(0.22, 1, 0.36, 1)`,
    zIndex: zIndexes.modal,
    width: ({ width }) => width,
    height: '100%',

    [breakpointMax('xs')]: {
      width: () => 320
    }
  },
  modalAfterOpen: {
    transform: 'translate(-50%, 0)'
  },
  modalBeforeClose: {
    transform: 'translate(-50%, 100%)'
  },

  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
}))

const rootElement = document.getElementById('root')

function FullScreenModal({ children, width, variant, overflow, ...props }) {
  const classes = useStyles({ width, variant, overflow })

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, { variant })
  )

  return (
    <Modal
      appElement={rootElement}
      closeTimeoutMS={closeTransitionDuration}
      className={{
        base: classes.modal,
        afterOpen: classes.modalAfterOpen,
        beforeClose: classes.modalBeforeClose
      }}
      overlayClassName={{
        base: classes.overlay,
        afterOpen: classes.overlayAfterOpen,
        beforeClose: classes.overlayBeforeClose
      }}
      aria={{
        label: props.ariaLabel ? props.ariaLabel : 'modal'
      }}
      {...props}
    >
      <div className={classes.container}>{childrenWithProps}</div>
    </Modal>
  )
}

FullScreenModal.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf(['compact', 'default']),
  overflow: PropTypes.oneOf(['hidden', 'visible'])
}

FullScreenModal.defaultProps = {
  width: '100%',
  variant: 'default',
  overflow: 'hidden'
}

export default FullScreenModal
